import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IIntelligenceSolutionBusinessPageItem } from "../../interfaces/IntelligenceSolutionBusinessPageItem";
import styles from "./IntelligenceSolutionItemCard.module.scss";
import enterpriseDesBackground from "../../assets/images/intelligence-solution/enterprise-des-backgroundV4.png";

interface IProps {
  item: IIntelligenceSolutionBusinessPageItem;
}

const IntelligenceSolutionItemCard = (props: IProps) => {
  const { item } = props;
  const navigate = useNavigate();

  return (
    <Col md={4} className="px-4 py-2">
      {/* <Row
        style={{
          backgroundImage: `url(${enterpriseDesBackground})`,
          backgroundPosition: "center",
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          borderRadius: "10px",
          color: "white",
          width: 108 + "%",
          height: "100%",
        }}
        className={["py-3 px-2 h-100", styles.itemCard].join(" ")}
        onClick={() =>
          navigate(item.title, {
            state: {
              nid: item.nid,
            },
          })
        }
      > */}
      <Row
        style={{
          background: "linear-gradient(to top, #accbee 0%, #e7f0fd 100%)",
          borderRadius: "10px",
          color: "white",
          width: "105%",
          height: "100%",
        }}
        className={["py-3 px-2 h-100", styles.itemCard].join(" ")}
        onClick={() =>
          navigate(item.title, {
            state: {
              nid: item.nid,
            },
          })
        }
      >
        <div className={styles.box} />
        <Col>
          <Row>
            <Col
              style={{ color: "#fff" }}
              className={[styles.cardTitle, "mb-3"].join(" ")}
            >
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <div
                className={styles.cardBody}
                dangerouslySetInnerHTML={{
                  __html: item.body.split(" ").join(" "),
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default IntelligenceSolutionItemCard;
